import { render, staticRenderFns } from "./TextAreaField.vue?vue&type=template&id=6cbaf5bc"
import script from "./TextAreaField.ts?vue&type=script&lang=ts&external"
export * from "./TextAreaField.ts?vue&type=script&lang=ts&external"
import style0 from "./TextAreaField.vue?vue&type=style&index=0&id=6cbaf5bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports